import { Component, input, output, signal, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'lib-pagination',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './pagination.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `
  ]
})
export class Pagination {
  totalPages = input<number>(1);
  initialPage = input<number>(0);
  pageChange = output<number>();

  currentPage = signal<number>(0);

  uiCurrent = computed(() => this.currentPage() + 1);

  constructor() {
    effect(() => {
      //quan canvia des del pare actualitza el component
      this.currentPage.set(this.initialPage());
    });
  }

  handlePageChange(uiPage: number) {
    if (uiPage < 1 || uiPage > this.totalPages()) return;
    const apiPage = uiPage - 1;

    this.currentPage.set(apiPage);
    this.pageChange.emit(apiPage);
  }
}